import script from "./ConferenceComment.vue?vue&type=script&setup=true&lang=js"
export * from "./ConferenceComment.vue?vue&type=script&setup=true&lang=js"

import "./ConferenceComment.vue?vue&type=style&index=0&id=d2c7d2c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2c7d2c0"]])

export default __exports__